import * as React from 'react';
import LayerParams from './LayerParams';
const useWMSLayers = (map, baseLayerChangedNum, wms) => {
    React.useEffect(() => {
        if (baseLayerChangedNum > 0) {
            if (!map)
                return;
            draw(map, wms);
        }
        return () => {
            if (!map || baseLayerChangedNum === 0)
                return;
            clear(map, wms);
        };
    }, [wms, baseLayerChangedNum]);
};
export default useWMSLayers;
const draw = (map, wms) => {
    var _a, _b;
    if (wms.tileURL === '')
        return;
    const layerWMS = `layer_${wms.label}`;
    const sourceWMSId = `source_${wms.label}`;
    const sourceWMS = 'wms';
    const layerMinZoom = (_a = wms.minZoom) !== null && _a !== void 0 ? _a : 12;
    map.addSource(sourceWMSId, {
        minzoom: layerMinZoom,
        type: 'raster',
        tiles: [wms.tileURL],
        tileSize: 256,
    });
    // if its stand map - we put wms under standFill
    const standFill = map.getLayer(LayerParams.standFill);
    // if its editor - we put wms under first draw layer
    const firstDrawLayer = (_b = map.getStyle().layers) === null || _b === void 0 ? void 0 : _b.find(l => l.id.match('gl-draw') || l.id.match('emptyLastLayer'));
    const before = standFill
        ? standFill.id
        : firstDrawLayer
            ? firstDrawLayer.id
            : undefined;
    map.addLayer({
        id: layerWMS,
        type: 'raster',
        source: sourceWMSId,
        'source-layer': sourceWMS,
        paint: {}
    }, before);
};
const clear = (map, wms) => {
    if (wms.tileURL === '')
        return;
    const layerWMS = `layer_${wms.label}`;
    const sourceWMSId = `source_${wms.label}`;
    map.removeLayer(layerWMS);
    if (map.getSource(layerWMS)) {
        map.removeSource(layerWMS);
    }
    map.removeSource(sourceWMSId);
};
